import React from 'react';
import { Icon } from './Icon.js';
export const IconEye = ({ ...props }) => {
    return (React.createElement(Icon, { size: "20px", ...props },
        React.createElement("path", { d: "m3.361,11.314c-.481-.8-.481-1.829,0-2.629.962-1.714,3.175-4.686,6.639-4.686s5.677,2.971,6.639,4.686c.481.8.481,1.829,0,2.629-.962,1.714-3.175,4.686-6.639,4.686s-5.677-2.857-6.639-4.686Z", fill: "none", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2" }),
        React.createElement("circle", { cx: "10", cy: "10", r: "3", fill: "currentColor", strokeWidth: "0", "data-color": "color-2" })));
};
//# sourceMappingURL=IconEye.js.map